<app-nav titulo="Home" descripcion="¡Bienvenido a Garantor!">
    <div class="broker-home">
        <div class="dashboard-card warranties-card">
            <span class="dashboard-card-title">
                Últimas garantías
            </span>
            <div class="warranties-list" *ngIf="latestWarranties?.length">
                <div class="warranty-card" *ngFor="let warranty of latestWarranties" routerLink="/garantias/{{ warranty.id }}">
                    <span class="warranty-id">{{ warranty.id }}</span>
                    <span class="warranty-address" *ngIf="warranty.propiedadDireccion">{{ warranty.propiedadDireccion.calle }} {{ warranty.propiedadDireccion.numero }}</span>
                    <span class="warranty-address" *ngIf="!warranty.propiedadDireccion">(Propiedad no seleccionada)</span>
                    <div class="warranty-status-box" [ngClass]="{ pending: ['DOCUMENTACION', 'PAGO_PENDIENTE', 'GENERAR_CONTRATO', 'AUTORIZACION_PENDIENTE', 'FIRMA_DIGITAL', 'FIRMA_PENDIENTE'].includes(warranty.estado), active: ['ACTIVA', 'FINALIZADA'].includes(warranty.estado), down: ['BAJA_ANTICIPADA', 'BAJA_POR_ADMIN', 'BAJA_POR_AGENTE'].includes(warranty.estado) }">
                        {{ warranty.estado.replaceAll('_', ' ') }}
                    </div>
                </div>
            </div>
            <div class="no-warranties" *ngIf="latestWarranties && !latestWarranties.length">
                No hay garantías.
            </div>
            <div class="loading" *ngIf="!latestWarranties">
                Cargando garantías...
            </div>
            <div class="dashboard-card-buttons">
                <button mat-raised-button color="primary" type="button" class="garantor-button mini" routerLink="/garantias">
                    Ver todas las garantías
                </button>
                <!-- <button mat-raised-button color="primary" type="button" class="garantor-button mini" routerLink="/cotizaciones/nueva">
                    Cotizar e iniciar garantía
                </button>
                <button mat-raised-button color="primary" type="button" class="garantor-button mini" (click)="openFastQuoteDialog()">
                    Cotización rápida
                </button> -->
            </div>
        </div>
        <form class="dashboard-card fast-warranty-card" [formGroup]="fastWarrantyFG" (submit)="sendFastWarranty()">
            <span class="dashboard-card-title">
                Garantía rápida
            </span>
            <span class="dashboard-card-description">
                Si no desea crear una cotización puede enviar los datos básicos al agente corporativo que luego contactará a los involucrados para comenzar la garantía.
            </span>
            <span class="section-title">Datos del inquilino</span>
            <form class="inputs-line" [formGroup]="fastWarrantyTenantFG">
                <mat-form-field class="garantor-form-field thin-form-field" appearance="outline">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="nombre">
                    <mat-error *ngIf="fastWarrantyTenantFG.controls.nombre.hasError('required')">
                        Parámetro requerido
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="garantor-form-field thin-form-field" appearance="outline">
                    <mat-label>Teléfono</mat-label>
                    <input matInput formControlName="telefono">
                    <mat-error *ngIf="fastWarrantyTenantFG.controls.telefono.hasError('required')">
                        Parámetro requerido
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="garantor-form-field thin-form-field" appearance="outline">
                    <mat-label>Documento</mat-label>
                    <input matInput formControlName="documento">
                </mat-form-field>
                <mat-form-field class="garantor-form-field thin-form-field" appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email">
                </mat-form-field>
            </form>
            <span class="section-title">Datos del propietario</span>
            <form class="inputs-line" [formGroup]="fastWarrantyOwnerFG">
                <mat-form-field class="garantor-form-field thin-form-field" appearance="outline">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="nombre">
                    <mat-error *ngIf="fastWarrantyOwnerFG.controls.nombre.hasError('required')">
                        Parámetro requerido
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="garantor-form-field thin-form-field" appearance="outline">
                    <mat-label>Teléfono</mat-label>
                    <input matInput formControlName="telefono">
                    <mat-error *ngIf="fastWarrantyOwnerFG.controls.telefono.hasError('required')">
                        Parámetro requerido
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="garantor-form-field thin-form-field" appearance="outline">
                    <mat-label>Documento</mat-label>
                    <input matInput formControlName="documento">
                </mat-form-field>
                <mat-form-field class="garantor-form-field thin-form-field" appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email">
                </mat-form-field>
            </form>
            <span class="section-title">Datos de la propiedad</span>
            <form class="inputs-line" [formGroup]="fastWarrantyPropertyFG">
                <mat-form-field class="garantor-form-field thin-form-field" appearance="outline">
                    <mat-label>Código Remax</mat-label>
                    <input matInput formControlName="codigoRemax">
                </mat-form-field>
                <mat-form-field class="garantor-form-field thin-form-field address-form-field" appearance="outline">
                    <mat-label>Dirección</mat-label>
                    <input matInput formControlName="direccion">
                </mat-form-field>
            </form>
            <div class="dashboard-card-buttons">
                <button mat-raised-button color="accent" type="submit" class="garantor-button">
                    Derivar a Garantor
                </button>
            </div>
        </form>
        <div class="dashboard-card warranty-status-chart-card">
            <span class="dashboard-card-title">
                Tus garantías
            </span>
            <div class="warranty-status-chart" [style.display]="warrantyStatusChartData && warrantyStatusChartData.total > 0 ? 'flex' : 'none'">
                <canvas #warrantyStatusChart></canvas>
            </div>
            <div class="no-warranties" *ngIf="warrantyStatusChartData && warrantyStatusChartData.total === 0">
                No hay garantías.
            </div>
            <div class="loading" *ngIf="!warrantyStatusChartData">
                Cargando estadísticas...
            </div>
            <div class="dashboard-card-buttons">
                <button mat-raised-button color="primary" type="button" class="garantor-button mini" routerLink="/propiedades/nueva">
                    Nueva propiedad
                </button>
                <button mat-raised-button color="primary" type="button" class="garantor-button mini" routerLink="/propietarios/nuevo">
                    Nuevo propietario
                </button>
            </div>
        </div>
    </div>
</app-nav>
